namespace Application.Models {
    'use strict';

    export interface IAlarm {
        deviceId: string;
        lastValue: AlarmLevelValue;
        valueDisplay: string;
        level: number;
        name: string;
        type: AlarmConfigType;
        masked: boolean;
        deviceName: string;
        deviceType: string;
        reason: string;
        confirmed: boolean;
        confirmComment: string;
        confirmUser: string;
        confirmDate: Date;
        extra: Object;
        relayedFrom: string;
        nameDisplay: string;
        templateHref: string;
        system: boolean;
        link?: string;
    }

    export interface IAlarmsInfo {
        currentAlarms: Models.IAlarm[];
        criticalNonHidden: number;
        allNonHidden: number;
    }

    export interface IAlarmsInfoHelper {
        currentCriticalAlarms: Models.IFlexEvent[];
        criticalNonHidden: number;
        allNonHidden: number;
    }

    export interface ICriticalCountResponse {
        some: boolean,
        count: number,
    }

    export class Alarm implements IAlarm {
        public static severityTexts: string[] = [
            'Critical low',
            'Major low',
            'Minor low',
            'Warning low',
            'Normal',
            'Warning high',
            'Minor high',
            'Major high',
            'Critical high',
        ];

        public static severityColors: string[] = [
            '#ff001d', // red
            '#ff8e2e', // orange
            '#ffc439', // yellow-orange
            '#fefe47', // yellow
            '#bcff45', // green-yellow
            '#fefe47', // yellow
            '#ffc439', // yellow-orange
            '#ff8e2e', // orange
            '#ff001d', // red
        ];

        public deviceId: string;
        public lastValue: AlarmLevelValue;
        public valueDisplay: string;
        public level: number;
        public name: string;
        public type: AlarmConfigType;
        public masked: boolean;
        public deviceName: string;
        public deviceType: string;
        public reason: string;
        public confirmed: boolean;
        public confirmComment: string;
        public confirmUser: string;
        public confirmDate: Date;
        public extra: Object;
        public relayedFrom: string;
        public nameDisplay: string;
        public templateHref: string;
        public system: boolean;

        public static getSeverityText(level: number): string {
            if (level === undefined || level > Alarm.severityTexts.length - 1)
                level = Alarm.severityTexts.length - 1;
            else if (level < 0)
                level = 0;
            return Alarm.severityTexts[level];
        }

        public static getSeverityColor(level: number): string {
            if (level === undefined || level > Alarm.severityColors.length - 1)
                level = Alarm.severityColors.length - 1;
            else if (level < 0)
                level = 0;
            return Alarm.severityColors[level];
        }

        public static getType(href: string): string {
            if (href) {
                let simpHref: string = Common.Utils.getSimplifiedHrefFromString(href);
                // tODO: move nodeTypes folder to networkNodeTypes
                if (simpHref.indexOf("networkNodeTypes")) {
                    simpHref = simpHref.replace("networkNodeTypes", "nodeTypes");
                }
                return "images" + simpHref + ".png";
            } else
                return undefined;
        }

        public static isCritical(level: number): boolean {
            return level === 0 || level === 8;
        }

        public static burnish(alarm: Alarm): Alarm {
            if (alarm && alarm.lastValue && typeof alarm.lastValue === 'number')
                alarm.lastValue = Common.Utils.round(alarm.lastValue, 6);
            if (alarm && alarm.nameDisplay === undefined)
                alarm.nameDisplay = alarm.name;
            return alarm;
        }
    }
}